document
  .querySelectorAll('.switch-page .select-items div')
  .forEach((element) => {
    element.addEventListener('click', function () {
      // get value of select .switch-page-select
      const select = document.querySelector(
        '.switch-page-select'
      ) as HTMLInputElement
      // switch to window location
      if (select) {
        window.location.href = select.value
      }
    })
  })
